<template>
  <flow-block-container
    @remove="$emit('remove')"
    @change-time="$emit('change-time', $event)"
    @lock-time="$emit('lock-time', $event)"
    :show-connection="showConnection"
    :item="value">

    <div style="">
      <font-awesome-icon :icon="['fab', 'google']" size="2x" style="float: right" />
      <h4><a :href="item.url" target="_blank">{{item.title}}</a></h4>
      <div>Duration {{sessionLength|hoursMinutes}}</div>
      <pre class="mini-pre" v-if="SHOW_DEBUG">{{item.config}}</pre>
    </div>
  </flow-block-container>
</template>

<script>
import FlowBlockContainer from './FlowBlockContainer'

export default {
  props: {
    value: {},
    showConnection: { default: true },
    isEditable: { default: true }
  },
  watch: {
    value: {
      handler(newValue) {
        this.item = newValue;
      },
      deep: true,
      immediate: true
    }
  },
  data: () => ({
    item: {}
  }),
  computed: {
    sessionLength() {
      return this.value.to - this.value.from
    }
  },
  methods: {
    onRemove() {
      this.$emit('remove');
    },
  },
  components: {
    FlowBlockContainer
  }
}
</script>
